import React from 'react';
import ReactDOM from 'react-dom';

import styles from './Portal.module.scss';

export const Portal = ({ children }: React.WithChildren) => {
  return ReactDOM.createPortal(<div className={styles.portal}>{children}</div>, document.getElementById('portal') ?? document.body);
};
